import axios from "axios";

export default {
    getCommunicationData: async (clientId, projectId=null) => {
        const { data } = await axios.get(`/communication/`, {
            params: {
                client_id: clientId,
                project_id: projectId
            }
        })

        return data
    },
    saveClientAutomation: async (clientId, projectId, emailAutomation) => {
        const { data } = await axios.post(`/communication/email`, {
            email_automation: emailAutomation,
            client_id: clientId,
            project_id: projectId
        })

        return data
    },
    postEmailLogPin: async (emailLogId, isPinned, clientId) => {
        const { data } = await axios.post(`/client/${clientId}/communication/email_log/${emailLogId}/pin`, {
            is_pinned: isPinned
        })

        return data
    },
    getEmailLog: async (emailLogId) => {
        const { data } = await axios.get(`/communication/email_log/${emailLogId}`)

        return data
    },
    resendFailedEmail: async (emailLogId) => {
        const { data } = await axios.post(`/communication/email_log/${emailLogId}/resend`, {})
        return data
    },
}